module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/UXdR7E/tc-custom/FC-9781398400801.jpg?1685327173448?1725649954027",
      "alt": "This image is the cover for the book HeartScapes"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("HeartScapes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Heartscapes explores ‘the greater love’ we see in people and the world around us. The ‘heart’ poems are the prayers of a contemplative set in the context of a long life that has known tragedy and suffering as well as love and many friendships. Heartscapes also includes salty wisdom about real life, love poems, stories, eco-poems, poems inspired by animals, translations, poems in memory of loved ones – and much more. It thus resonates with all the living, human and animate that I encounter, as well as the landscape and seascape we are blessed with in Aotearoa/New Zealand. Hand in hand with indigenous peoples, Maori, Aboriginal, Pacific, I’m trying to recover a sense of the sacred we have lost in our western science- and info-based culture.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Raymond Pelly\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Raymond Pelly is an Anglican Priest & theologian resident (since 1977) in Aotearoa, New Zealand. Born in London in 1938, where he experienced the Blitz, he has worked as a teacher in Cambridge (UK), Boston/Cambridge (MA), Auckland (NZ). He is married to Barbara Craig, father of six children, two deceased. His book, Pilgrim to Unholy Places, investigates the implications of the Holocaust for Jewish-Christian dialogue and belief generally. His Heartscape poems explore ‘deep mind’, the well-springs of passionate creativity and a strong love that embraces people as well as land and seascape. Raymond speaks French& German; some of his best writing has been done in Contemplative/Carmelite Communities in Berlin, Weimar, Dachau & Esterwegen/Emsland.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0